import { CityDropdownForTrip, CommonDateRange, CustomSelect } from 'components';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { UserContext } from 'context';
import { getAllVehicleNumber, getStatesData } from '_services';
import moment from 'moment';
import StorageService from 'utils/StorageServices/StorageServices';
import { getBranchDropdownListData, getConsignorDropdownListData, getDriverDropdownListData, getSupplierDropdownListData } from '_services/dropdownServices/dropdownService';
import toast from 'react-hot-toast';
import { getCityLocationList } from '_services/accountsServices/cityLocationService';

const CommonReportFilters = (props) => {

    let {
        filter,
        setFilter,
        isPartyDropdown = true,
        isBranchDropdown = true,
        isVehicleOwnershipDropdown = true,
        isVehicleNumberDropdown = true,
        isSupplierDropdown = true,
        isFromStationDropdown = true,
        isToStationDropdown = true,
        isPodStatusDropdown = true,
        isEwayBillStatusDropdown = true,
        isDriverDropdown = true,
        isStatusDropdown = true,
        isLrStatusDropdown = true,
    } = props;

    const { masterData, cities } = useContext(UserContext)
    const [dropdownBranchList, setDropdownBranchList] = useState([]);
    const [consignorList, setConsignorList] = useState([]);
    const [vehicleNumbList, setVehicleNumbList] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [driverList, setDriverList] = useState([]);

    const [masterDataStatus, setMasterDataStatus] = useState([]);
    const [masterDataLrStatus, setMasterDataLrStatus] = useState([]);
    const [masterDataPodStatus, setMasterDataPodStatus] = useState([]);
    const [masterDataEwayBill, setMasterDataEwayBill] = useState([]);
    const [masterDataOwnerShip, setMasterDataOwnerShip] = useState([]);

    useEffect(() => {
        if (masterData?.trip_status_list) {
            setMasterDataStatus(masterData?.trip_status_list?.map((i) => {
                return {
                    label: i?.name,
                    value: i?.id,
                };
            }))
        }
        if (masterData?.lr_status_list) {
            setMasterDataLrStatus(masterData?.lr_status_list?.map((i) => {
                return {
                    label: i?.name,
                    value: i?.id,
                };
            }))
        }
        if (masterData?.pod_status_list) {
            setMasterDataPodStatus(masterData?.pod_status_list?.map((el) => {
                return {
                    label: el?.name,
                    value: el?.id,
                };
            }))
        }
        if (masterData?.eway_bill_status_list) {
            setMasterDataEwayBill(masterData?.eway_bill_status_list?.map((el) => {
                return {
                    label: el?.name,
                    value: el?.id,
                };
            }))
        }

        if (masterData?.vehicle_ownership_list) {
            setMasterDataOwnerShip(masterData?.vehicle_ownership_list?.map((el) => ({
                label: el?.name,
                value: el?.id,
            })))
        }
    }, [masterData])

    const fetchVehicleList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 2000,
                offset: 1,
                search: "",
                vehicle_ownership: [1, 3]
            };
            const vehicleRes = await getAllVehicleNumber(object);
            if (vehicleRes?.responseCode === 200) {
                const newVehicles = vehicleRes.data?.vehicle_list.map((i) => ({
                    ...i,
                    label: i.vehicle_no,
                    value: i._id,
                }));
                let newData = {
                    vehicle_no: 'All',
                    label: 'All',
                    value: '',
                    lorry_type_id: {
                        _id: '',
                        lorry_type: ''
                    },
                    vehicle_ownership: 1,
                    vehicle_status: 1,
                    vehicle_type_id: {
                        _id: '',
                        name: 'All'
                    },
                    vehicle_type_id_1: {
                        _id: '',
                        name: 'All'
                    }
                }
                setVehicleNumbList([newData, ...newVehicles]);
            } else {
                toast.error(vehicleRes?.responseMessage);
            }
        } catch (error) {
            toast.error("Error fetching vehicle list.");
        }
    };

    const getDropdownDataBranchList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                search: "",
            };
            const res = await getBranchDropdownListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.branch_list?.map((el) => {
                    return {
                        label: el?.branch,
                        value: el?._id,
                    }
                })
                setDropdownBranchList(data);
            }
        } catch (error) { }
    };

    const getDropdownDataConsignorList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: 100,
                offset: 1,
                search: '',
            }
            const res = await getConsignorDropdownListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.consignor_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })
                setConsignorList(data)
            }
        } catch (error) {
            // throw error;
        }
    }

    const getDropdownDataSupplierList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: 100,
                offset: 1,
            }
            const res = await getSupplierDropdownListData(object);
            if (res?.responseCode == 200) {
                let list = res?.data?.supplier_list.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    };
                });
                setSupplierList(list)
            } else {
                // setLoading(false);
            }
        } catch (error) {
            // setLoading(false);
            // throw error;
        }
    }

    const getDropdownDriverList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                search: '',
                status: 1,
                driver_type: 0,
            }
            const res = await getDriverDropdownListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.driver_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })
                setDriverList(data)
            }
        } catch (error) {
            // throw error;
        }
    }

    useEffect(() => {
        if (isVehicleNumberDropdown) {
            fetchVehicleList();
        }
        if (isBranchDropdown) {
            getDropdownDataBranchList();
        }
        if (isSupplierDropdown) {
            getDropdownDataSupplierList();
        }
        if (isPartyDropdown) {
            getDropdownDataConsignorList();
        }
        if (isDriverDropdown) {
            getDropdownDriverList();
        }
    }, [])

    useEffect(() => {
        if (vehicleNumbList?.length > 0) {
            setFilter((s) => ({
                ...s,
                vehicle_id: vehicleNumbList[0],
            }))
        }
    }, [vehicleNumbList])

    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setFilter((s) => ({
            ...s,
            start_date: moment(newRange?.startDate).format("YYYY-MM-DD"),
            end_date: moment(newRange?.endDate).format("YYYY-MM-DD"),
        }));
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...filter, [name]: item };
        setFilter(stateObj);
    };

    const resetFunction = () => {
        const newStartDate = moment().startOf('month');
        const newEndDate = moment().endOf('month');

        setSelectedRange({
            startDate: newStartDate,
            endDate: newEndDate,
        });

        setFilter((s) => ({
            ...s,
            offset: 1,
        }));
    };

    const fetchFromCity = useCallback(async (search, page, limit) => {
        try {
            const response = await getCityLocationList({
                countryCode: "IN",
                stateCode: "",
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const cities = response.data.all_cities.map(city => ({
                    ...city,
                    _id: city.name,
                    value: city.name,
                    label: city.name, // `${city.name}, ${city.stateName}`
                }));

                const result = {
                    items: cities, // [{ label: 'All Location', value: '' }, ...cities],
                    total: response.data.total_record,
                };
                return result;
            }
            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    return (
        <>
            <div className='_mrktFilt_mainBx'>
                <div className='ctbx_childBox'>
                    <div className='head_load'>
                        <span className="search_loads"> Filters </span>
                        {/* <button className='reSet_btn' onClick={(e) => resetFunction(e)}>Reset</button> */}
                    </div>
                    <div className='_optFilts'>
                        <div style={{ marginBottom: '20px' }}>
                            <CommonDateRange
                                key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                initialStartDate={selectedRange.startDate}
                                initialEndDate={selectedRange.endDate}
                                onApply={handleApply}
                            />
                        </div>

                        {isBranchDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                label='Branch'
                                placeholder="All"
                                options={[{ label: "All", value: "" }, ...dropdownBranchList]}
                                value={filter?.branch_id}
                                onSelect={(data) => onhandleSelect(data, 'branch_id')}
                            />
                        </div>}

                        {isPartyDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                label='Party'
                                placeholder="All"
                                options={[{ label: "All", value: "" }, ...consignorList]}
                                value={filter?.consignor_id}
                                onSelect={(data) => onhandleSelect(data, 'consignor_id')}
                            />
                        </div>}


                        {isVehicleOwnershipDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...masterDataOwnerShip]}
                                name="ownership_no"
                                label="Ownership"
                                placeholder="All"
                                value={filter?.ownership_no}
                                onSelect={(data) => onhandleSelect(data, 'ownership_no')}
                            />
                        </div>}

                        {isVehicleNumberDropdown && <div className='__trps_select' style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                label="Vehicle Number"
                                placeholder="All"
                                options={vehicleNumbList}
                                value={filter?.vehicle_id}
                                component_class="vehicle_number_trip"
                                onSelect={(data) => onhandleSelect(data, 'vehicle_id')}
                            />
                        </div>}

                        {isSupplierDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...supplierList]}
                                label="Supplier"
                                placeholder="All"
                                name="supplier_id"
                                value={filter?.supplier_id}
                                onSelect={(data) => onhandleSelect(data, 'supplier_id')}
                            />
                        </div>}

                        {isFromStationDropdown && <div style={{ marginBottom: '20px' }}>
                            <CityDropdownForTrip
                                label="From Station"
                                placeholder="From Station"
                                inputClass="customSelect_invitation"
                                fetchData={fetchFromCity}
                                pageSize={20}
                                selectedItem={filter?.from_location}
                                onChange={(data) => onhandleSelect(data, 'from_location')}
                            />
                            {/* <CustomSelect
                                options={[{ label: 'All', value: '', cityStateLabel: 'All' }, ...cities]}
                                optionShowCityState={true}
                                label="From Station"
                                placeholder="All"
                                name="from_location"
                                value={filter?.from_location}
                                onSelect={(data) => onhandleSelect(data, 'from_location')}
                            /> */}
                        </div>}

                        {isToStationDropdown && <div style={{ marginBottom: '20px' }}>
                            <CityDropdownForTrip
                                label="To Station"
                                placeholder="To Station"
                                inputClass="customSelect_invitation"
                                fetchData={fetchFromCity}
                                pageSize={20}
                                selectedItem={filter?.to_location}
                                onChange={(data) => onhandleSelect(data, 'to_location')}
                            />
                            {/* <CustomSelect
                                options={[{ label: 'All', value: '', cityStateLabel: 'All' }, ...cities]}
                                optionShowCityState={true}
                                label="To Station"
                                placeholder="All"
                                name="to_location"
                                value={filter?.to_location}
                                onSelect={(data) => onhandleSelect(data, 'to_location')}
                            /> */}
                        </div>}

                        {isEwayBillStatusDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...masterDataEwayBill]}
                                label="Eway Bill Status"
                                placeholder="All"
                                name="eway_bill_status"
                                value={filter?.eway_bill_status}
                                onSelect={(data) => onhandleSelect(data, 'eway_bill_status')}
                            />
                        </div>}

                        {isPodStatusDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...masterDataPodStatus]}
                                label="POD Status"
                                placeholder="All"
                                name="pod_status"
                                value={filter?.pod_status}
                                onSelect={(data) => onhandleSelect(data, 'pod_status')}
                            />
                        </div>}

                        {isDriverDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...driverList]}
                                label="Driver"
                                placeholder="All"
                                name="driver_id"
                                value={filter?.driver_id}
                                onSelect={(data) => onhandleSelect(data, 'driver_id')}
                            />
                        </div>}

                        {isStatusDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...masterDataStatus]}
                                label="Status"
                                placeholder="All"
                                name="status"
                                value={filter?.status}
                                onSelect={(data) => onhandleSelect(data, 'status')}
                            />
                        </div>}

                        {isLrStatusDropdown && <div style={{ marginBottom: '20px' }}>
                            <CustomSelect
                                options={[{ label: 'All', value: '' }, ...masterDataLrStatus]}
                                label="Status"
                                placeholder="All"
                                name="status"
                                value={filter?.status}
                                onSelect={(data) => onhandleSelect(data, 'status')}
                            />
                        </div>}

                    </div>
                </div>
            </div>
        </>
    )
}

export default React.memo(CommonReportFilters)